/** @format */

import React from 'react';
import './styles.scss';
import PageLayout from 'components/Layout/Page';
import {
  LeadsSectionBody,
  LeadSources,
  LeadTypes
} from 'components/LeadsGenerator';

export default function LeadsCommonPage(props) {
  const text = props.t('lang_common:leads_page:validate');

  const ImageSection = () => {
    return (
      <img
        src='/images/leads-validate-page.jpg'
        className='validate-page-image'
        alt='leads sell image'
      />
    );

    // return <></>;
  };
  return (
    <PageLayout mainContainerClassName='leads-page validate-page' {...props}>
      <div className='validate-page-wrapper'>
        <div className='form-section'>
          <div className='header-section'>
            <h3>{text?.heading}</h3>
            <p className='text2r'>{text?.headerParagraph}</p>
          </div>
          <LeadsSectionBody
            metadata={{
              source: LeadSources.FM_EVALUATE
            }}
            defaultLeadType={LeadTypes.FREE_VALUATION}
            {...props}
          />
        </div>
        <div className='image-section'>
          <ImageSection />
        </div>
      </div>
    </PageLayout>
  );
}
